export default "__VITE_ASSET__Dgx5MTSP__"